import { defineComponent } from "vue";
import common from "../core/core";

export default defineComponent({
  components: {},
  data() {
    return {
      ready: false,
      opened: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
  },
  mixins: [common],
});
